import { useTranslation } from 'react-i18next';
import { Card, CardBody, CardHeader } from '../../../components/card/card';
import PerfectScrollbar from 'react-perfect-scrollbar';
import NoData from '../../../components/NoData/NoData';

type Props = {
  title: string;
  List?: any[];
  url?: string;
};
export const ModuleCard2 = ({ title, List, url }: Props) => {
  const { i18n, t } = useTranslation();

  // const navigate = useNavigate();

  return (
    <div className="col-xl-3 col-lg-6">
      <Card className="record-card">
        <CardHeader className="d-flex justify-content-between align-items-center p-3 border-0">
          <div className="d-flex align-items-center">
            <div className="record-status-indicator"></div>
            {/* <h6 className="mb-0 ms-2">Records Group {index + 1}</h6> */}
            <h6 className="mb-0 ms-2"> {title}</h6>
          </div>
          {/* <div className="card-actions">
              <button className="btn btn-icon btn-light btn-xs me-1">
                <i className="bi bi-search"></i>
              </button>
              <button className="btn btn-icon btn-light btn-xs">
                <i className="bi bi-three-dots-vertical"></i>
              </button>
            </div> */}
        </CardHeader>

        <CardBody className="p-0">
          <PerfectScrollbar className="records-scroll">
            {List?.map((record) => (
              <div key={record.id} className="record-item">
                <div className="record-content">
                  <div className="record-icon">
                    {/* <i className={`${record.icon}`}></i> */}
                    <i className={record.icon ? record.icon : 'fa fa-box'}></i>
                  </div>
                  <div className="record-details">
                    {/* <div className="record-name">{isRTL ? record.name2 : record.name}</div> */}
                    <div className="record-name">
                      {i18n.language === 'en' ? record.name : record.name2}
                    </div>
                    <small className="record-table">{record.tableName}</small>
                  </div>
                  {/* <div className="record-actions">
                    <button className="action-btn edit">
                      <i className="bi bi-pencil"></i>
                    </button>
                    <button className="action-btn view">
                      <i className="bi bi-eye"></i>
                    </button>
                  </div> */}
                </div>
              </div>
            ))}

            {List?.length === 0 && <NoData />}
          </PerfectScrollbar>

          <div className="card-footer border-0 bg-theme bg-opacity-10 p-2">
            <div className="d-flex justify-content-between align-items-center">
              <div className="bg-theme bg-opacity-15 p-1 rounded-0">
                <span className="text-theme fw-bold">{List?.length}</span> {t('Records')}
              </div>
              {/* <button
                className="btn btn-xs btn-theme"
                onClick={() => {
                  if (url) {
                    window.open(url, '_blank');
                  }
                }}>
                View All
              </button> */}
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};
